// components/ui/ReturnButton.js
import React from 'react';

const ReturnButton = ({ text = "Назад", className = "", onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(e); // Используем переданный onClick
    } else {
      window.history.back(); // По умолчанию
    }
  };

  return (
    <a 
      href="#" 
      className={`returnbtnA, category-return-btn`}
      onClick={handleClick}
    >
      <div className="returnBtnWrapper flex-row">
        <div className="returnBtn flex-row">
          <img 
            className="sign returnArrow" 
            src="/elements/returnArrow.svg" 
            alt="Вернуться назад" 
          />
          <p className="returnBtnText">{text}</p>
        </div>
      </div>
    </a>
  );
};

export default ReturnButton;